import FeatherIcons from '@expo/vector-icons/Feather'
import { useTheme } from 'contexts'
import React from 'react'

import { Box } from 'widgets/Box'

import { CustomIconExists, CustomIcons } from './icons/custom'
import { Props } from './types'

export const Icon = ({ name, size = 24, padding, color = 'white', rotation = 0 }: Props) => {
  const theme = useTheme()
  const computedStyle = {
    color,
    transform: [{ rotateZ: `${rotation}deg` }],
  }

  let finalIcon
  if (CustomIconExists(name)) {
    const CustomIcon = CustomIcons[name]
    finalIcon = <CustomIcon color={theme.colors[color]} height={size} width={size} />
  } else {
    finalIcon = <FeatherIcons color={theme.colors[color]} name={name} size={size} />
  }

  return (
    <Box
      style={computedStyle}
      padding={padding}
      width={size}
      height={size}
      justifyContent='center'
      align='center'
    >
      {finalIcon}
    </Box>
  )
}
